/*jshint esversion: 6 */

import WidgetShortList from "../widgets/WidgetShortList";
import GenericSearch from '../forms/search/GenericSearch.js';
import CategorySearch from '../forms/search/CategorySearch.js';
import FilterSearch from '../forms/search/FilterSearch.js';
import dialogPolyfill from 'dialog-polyfill/dialog-polyfill'
import ClipboardJS from 'clipboard';
import WidgetJournalRatingForm from "../widgets/WidgetJournalRatingForm";
import { Offcanvas } from "bootstrap";

GenericSearch();
FilterSearch();
CategorySearch({
    locale: LOCALE,
    env: ENV,
});

WidgetShortList({
    selector: 'btn-shortlist',
    locale: LOCALE,
    env: ENV,
    route: "/widget/shortlist/%type%/%id%"
})

const modal = document.querySelector('dialog');
if(modal) {
    dialogPolyfill.registerDialog(modal);
}

let dialog = document.querySelector('dialog.article-citation');
if(dialog) {
    document.querySelector('#btn-cite-show').onclick = function () {
        dialog.show();
    };
    document.querySelector('#btn-cite-close').onclick = function () {
        dialog.close();
    };
    let clipboard = new ClipboardJS('#btn-cite-copy');
    clipboard.on('success', function(e){
        e.clearSelection();
        document.getElementById('btn-cite-copy').classList.add('hidden');
        document.getElementById('btn-cite-copied').classList.remove('hidden');
    });
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Journal rating modal
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

// rating modal setup and distance scrolled based opening
let ratingFormSelector = 'dialog.journal-rating-modal';
let ratingSubmitBtn = document.querySelector(ratingFormSelector+' .submit-button');
if (ratingSubmitBtn) {
    let modalCloseBtn = document.querySelector(ratingFormSelector+' .close-button');
    let ratingForm = WidgetJournalRatingForm({
        locale: LOCALE,
        env: ENV,
        route: "/widget/journal/%id%/rating",
        modalSelector: ratingFormSelector
    });
    let ratingFormDisplayDistance = (document.body.scrollHeight / 3) * 2;
    let showModal = true;
    let articleId = ratingForm.getJournalArticleId('#btn-cite-show');
    let ratingModalOpenBtns = document.querySelectorAll('.journal-rating-modal-open');

    // show modal once scrolled down an amount of pixels
    let scrollDistanceTest = function (distance) {
        let y = window.scrollY;
        if (y >= distance) {
            showModalOnce(articleId);
        }
    };
    let scrollCheck = function() {
        scrollDistanceTest(ratingFormDisplayDistance);
    }
    let showModalOnce = function(articleId) {
        if(showModal === true) {
            ratingForm.buildForm(articleId);
            showModal = false;
        }
    }
    window.addEventListener("scroll", scrollCheck);

    // rating modal open button
    if (ratingModalOpenBtns) {
        ratingModalOpenBtns.forEach(function(ratingModalOpenBtn) {
            ratingModalOpenBtn.onclick = function () {
                ratingForm.buildForm(articleId);
            }
        });
    }

    ratingSubmitBtn.onclick = function () {
        console.log('submit form');
        ratingForm.submitForm();
    }

    modalCloseBtn.onclick = function () {
        ratingForm.closeDialog();
    }
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Journal table of contents
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

let tocContent = document.getElementById('nav-toc');

if (tocContent != null) {
    let i, elems, content, tocHTML = '';
    let idPrefix = 'toc-item-';

    let buildTOCItemHTML = function(content, id, tocClasses = '') {
        return '<a href="#' + id + '" class="nav-link ' + tocClasses + '">' + content + '</a>';
    }
    let buildTOCNavTarget = function(id) {
        let span = document.createElement("span");
        span.id = id;
        return span;
    }

    content = document.querySelector('.journal-article-item.full .article-content');
    elems = content.querySelectorAll('h2, h3, b');

    let allowedHeadings = [
        'table ', 'figure ', 'figure/video ', 'video '
    ];

    let isAllowedHeading = function (heading, allowed) {
        let state = false;
        allowed.forEach(allowedValue => {
            if (heading.toLowerCase().startsWith(allowedValue.toLowerCase())) {
                state = true;
            };
        });
        return state;
    };

    for (i =0; i < elems.length; i++) {
        let id = idPrefix + i;
        if (elems[i].localName === 'h2') {
            elems[i].before(buildTOCNavTarget(id));
            tocHTML += buildTOCItemHTML(elems[i].textContent, id);
        } else if (elems[i].localName === 'h3') {
            elems[i].before(buildTOCNavTarget(id));
            tocHTML += buildTOCItemHTML(elems[i].textContent, id, 'ms-1');
        } else if (elems[i].localName === 'b') {
            if (isAllowedHeading(elems[i].textContent, allowedHeadings)) {
                elems[i].before(buildTOCNavTarget(id));
                tocHTML += buildTOCItemHTML(elems[i].textContent.split('.')[0], id, 'ms-2');
            }
        }
    }

    tocContent.innerHTML = tocHTML;

    // TOC hide menu for smaller resolutions
    const keepTOCWidth = 2150;
    function closeTOC(event, id) {
        if(window.innerWidth < keepTOCWidth) {
            Offcanvas.getInstance(document.getElementById(id)).hide();
            console.log('toc hidden');
        }
    }

    const tocEl = document.getElementById("offcanvasScrollingTOC");
    tocEl.addEventListener("click", (event) => {
        closeTOC(event, tocEl.id);
    }, false);

    // TOC fixed icon appear/disappear on scroll
    const tocQuickLink = document.querySelector(".toc-quick-link");

    new IntersectionObserver(topObserver => {
        topObserver[0].boundingClientRect.y < -26 ? (tocQuickLink.dataset.visible = true, console.log('toc true vis'+topObserver[0].boundingClientRect.y)) : (tocQuickLink.dataset.visible = false, console.log('toc false vis'+topObserver[0].boundingClientRect.y));
    }).observe(document.querySelector(".btn-toc"));
}